"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Parser = void 0;
var constant_1 = require("../constant");
// 暂时从原函数中import
var FormatUtils_1 = require("../../utils/FormatUtils");
var Parser = /** @class */ (function () {
    function Parser(value, tokenizedList, context) {
        this.currentIndex = 0;
        this.isNumberStringContainsFraction = false;
        // 结果变量
        this.parsedNumberString = '';
        this.outputNumberType = constant_1.NumberLanguageCaseType.Default;
        this.needCutEndPercentageLabel = false;
        this.numberFormatTokenIndexes = [];
        this.colorFormat = null;
        this.value = value;
        this.tokenizedList = tokenizedList;
        this.formatDate = context === null || context === void 0 ? void 0 : context.formatDate;
        this.subsecondDecimalNumber = context === null || context === void 0 ? void 0 : context.subsecondDecimalNumber;
    }
    /**
     * 扫描格式串数值进行解析
     */
    // eslint-disable-next-line complexity
    Parser.prototype.run = function () {
        for (; this.currentIndex < this.tokenizedList.length; this.currentIndex++) {
            this.currentToken = this.tokenizedList[this.currentIndex];
            this.currentTokenType = this.currentToken.type;
            this.currentTokenValue = this.currentToken.value;
            // 扫描解析分词数组
            switch (this.currentTokenType) {
                case constant_1.TokenType.Text:
                case constant_1.TokenType.TextPlaceholder:
                case constant_1.TokenType.Space:
                case constant_1.TokenType.Digit:
                    break;
                case constant_1.TokenType.SpecialStartGenesis:
                    this.handleSpecialStartGenesis();
                    break;
                case constant_1.TokenType.Day:
                case constant_1.TokenType.Month:
                case constant_1.TokenType.Year:
                case constant_1.TokenType.HalfDayHours:
                case constant_1.TokenType.FullDayHours:
                case constant_1.TokenType.Minute:
                case constant_1.TokenType.Second:
                case constant_1.TokenType.Era:
                case constant_1.TokenType.BuddhistYear:
                case constant_1.TokenType.AbsoluteTime:
                case constant_1.TokenType.Week:
                    this.handleDateTimeRelated();
                    break;
                case constant_1.TokenType.Number:
                case constant_1.TokenType.LeftParenthesis:
                case constant_1.TokenType.QuestionMark:
                    this.handleNumeralRelated();
                    break;
                case constant_1.TokenType.General:
                    this.handleGeneral();
                    break;
                case constant_1.TokenType.ChineseNumber:
                    this.handleNumberType();
                    break;
                case constant_1.TokenType.Color:
                    this.handleColor();
                    break;
                default:
                    break;
            }
        }
    };
    Parser.prototype.getParsedResult = function () {
        return {
            parsedNumberString: this.parsedNumberString,
            outputNumType: this.outputNumberType,
            needCutEndPercentageLabel: this.needCutEndPercentageLabel,
            numberFormatTokenIndexes: this.numberFormatTokenIndexes,
            colorFormat: this.colorFormat,
        };
    };
    /**
     * 对特殊参考时间分词进行解析
     */
    Parser.prototype.handleSpecialStartGenesis = function () {
        // 暂不处理
        this.currentToken.value = '';
        this.currentToken.type = constant_1.TokenType.Empty;
    };
    /**
     * 对其余时间相关分词进行解析
     */
    Parser.prototype.handleDateTimeRelated = function () {
        if (!this.currentTokenValue) {
            return;
        }
        // 解析日期时间值
        // TODO: 暂时用转换后的日期时间类对象进行求值, 后续删除
        this.currentToken.value = FormatUtils_1.write_date(this.currentTokenType.charCodeAt(0), this.currentTokenValue, this.convertFormatDate(), this.subsecondDecimalNumber);
        this.currentToken.type = constant_1.TokenType.Text;
    };
    /**
     * 对数值类分词进行解析
     */
    Parser.prototype.handleNumeralRelated = function () {
        var tempIndex = this.currentIndex + 1;
        // 解析百分号
        if (this.currentTokenType === constant_1.TokenType.Number && this.currentTokenValue === '%') {
            this.parsedNumberString += this.currentTokenValue;
            this.needCutEndPercentageLabel = true;
            return;
        }
        // 截取之后表示数值类型的格式串分词, 将他们统一为一个分词
        while (this.isTokenTypeNumber(tempIndex)) {
            this.currentToken.value += String(this.tokenizedList[tempIndex].value);
            this.tokenizedList[tempIndex] = {
                value: '',
                type: constant_1.TokenType.Empty,
            };
            tempIndex += 1;
        }
        // 如果括号后面直接跟数值类型, 放入 nstr 里面去处理; 如果不是则不放入
        if (!this.isIncludedParsedNumberString(tempIndex)) {
            this.currentIndex = tempIndex - 1;
            return;
        }
        // 添加解析的数值字符
        this.parsedNumberString += this.tokenizedList[this.currentIndex].value;
        // 记录数值类型在分词数组中的下标
        this.numberFormatTokenIndexes.push(this.currentIndex);
        this.currentIndex = tempIndex - 1;
        // 去掉跟在数字后面的逗号占位符
        this.tokenizedList[this.currentIndex].value = String(this.tokenizedList[this.currentIndex].value).replace(/([0#?]+),+$/, '$1');
    };
    /**
     * 对数字展示类型进行解析
     */
    Parser.prototype.handleNumberType = function () {
        this.outputNumberType = String(this.currentTokenValue).replace(/\[DBNum(\d)\]/, '$1');
        this.currentToken.type = constant_1.TokenType.Text;
        this.currentToken.value = '';
    };
    /**
     * 对常规分词进行解析
     */
    Parser.prototype.handleGeneral = function () {
        this.currentToken.type = constant_1.TokenType.Text;
        this.currentToken.value = FormatUtils_1.general_fmt(this.value);
    };
    /**
     * 对颜色类分词进行解析
     */
    Parser.prototype.handleColor = function () {
        this.colorFormat = this.currentToken.value;
        // 提取颜色后该分词可废弃
        this.currentToken.type = constant_1.TokenType.Text;
        this.currentToken.value = '';
    };
    /**
     * @param judgeIndex 需要判断的分词数组下标
     * 判断该分词是否属于数值类分词
     */
    // eslint-disable-next-line complexity
    Parser.prototype.isTokenTypeNumber = function (judgeIndex) {
        // 当前需判断下标无分词, 直接返回
        if (!this.tokenizedList[judgeIndex]) {
            return false;
        }
        // 获取需要判断的分词的类型和值
        var judgeTokenType = this.tokenizedList[judgeIndex].type;
        var judgeTokenValue = this.tokenizedList[judgeIndex].value;
        // 1. 待判断分词类型为 ? 占位符或者 数字字符 时
        if (judgeTokenType === constant_1.TokenType.QuestionMark) {
            return true;
        }
        // 2. 数字字符仅有在存在分数符号时才会被纳入考虑
        if (judgeTokenType === constant_1.TokenType.Digit && this.isNumberStringContainsFraction) {
            return true;
        }
        // 3. 表示括号内的内容
        if (this.currentTokenType === constant_1.TokenType.LeftParenthesis
            && (judgeTokenType === constant_1.TokenType.Space
                || judgeTokenType === constant_1.TokenType.Number
                || judgeTokenType === constant_1.TokenType.RightParenthesis)) {
            return true;
        }
        // 获取待判断分词的下一个分词的信息
        if (!this.tokenizedList[judgeIndex + 1]) {
            return false;
        }
        var tokenTypeAfterJudgeToken = this.tokenizedList[judgeIndex + 1].type;
        var tokenValueAfterJudgeToken = this.tokenizedList[judgeIndex + 1].value;
        // 4. 表示分数的除号
        if (judgeTokenType === constant_1.TokenType.Text) {
            if (judgeTokenValue === '/') {
                this.isNumberStringContainsFraction = true;
                return true;
            }
        }
        // 5. 表示占位符 ？ 中间的空格时
        if (judgeTokenType === constant_1.TokenType.Space && tokenTypeAfterJudgeToken === constant_1.TokenType.QuestionMark) {
            return true;
        }
        // 6. 同样表示分数
        if ((judgeTokenType === constant_1.TokenType.Space || judgeTokenType === constant_1.TokenType.Text)
            && (tokenTypeAfterJudgeToken === constant_1.TokenType.QuestionMark
                || (tokenTypeAfterJudgeToken === constant_1.TokenType.Text
                    && tokenValueAfterJudgeToken === '/')
                || (this.isNumberStringContainsFraction
                    && tokenTypeAfterJudgeToken === constant_1.TokenType.Digit))) {
            return true;
        }
        return false;
    };
    /**
     * 判断括号后的值是否需要囊括在解析的数值格式串中
     * @param judgeIndex 相关判断的分词数组
     */
    Parser.prototype.isIncludedParsedNumberString = function (judgeIndex) {
        var _a;
        if (this.currentTokenType === constant_1.TokenType.LeftParenthesis
            && this.tokenizedList[this.currentIndex].value === '(') {
            // 1. 括号后分词数组结束
            if (judgeIndex === this.tokenizedList.length) {
                return false;
            }
            // 2. 括号后不是数值类格式分词
            if (((_a = this.tokenizedList[judgeIndex]) === null || _a === void 0 ? void 0 : _a.type) !== constant_1.TokenType.Number) {
                return false;
            }
        }
        return true;
    };
    /**
     * 将现在新的时间日期类格式转换为老的数据格式用来求值
     * TODO: 后续删除
     */
    Parser.prototype.convertFormatDate = function () {
        var _this = this;
        if (!this.formatDate) {
            return null;
        }
        var keyMap = {
            date: 'D',
            time: 'T',
            subsecond: 'u',
            year: 'y',
            month: 'm',
            day: 'd',
            hour: 'H',
            minute: 'M',
            second: 'S',
            week: 'q',
        };
        // @ts-ignore
        return Object.keys(this.formatDate).reduce(function (convertObject, currentKey) {
            // @ts-ignore
            convertObject[keyMap[currentKey]] = _this.formatDate[currentKey];
            return convertObject;
        }, {});
    };
    return Parser;
}());
exports.Parser = Parser;
//# sourceMappingURL=parser.js.map